import { styled } from '@mui/material';
import FlexBox from 'Components/FlexBox';
import ThemeTypography from 'DesignSystem/Primitives/Typography/ThemeTypography';
import React, { FC } from 'react';

export enum ECountryRiskLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export type TCountryRiskLevel = `${ECountryRiskLevel}`;

interface ICountryRiskLevelProps {
  riskLevel: TCountryRiskLevel;
  usePluralLabel?: boolean;
  customLabel?: string;
}

const RISK_LEVEL_ITEMS: Record<TCountryRiskLevel, { label: string; color: string }> = {
  LOW: { label: 'Low-risk country', color: '#247B52' },
  MEDIUM: { label: 'Standard-risk country', color: '#FFB801' },
  HIGH: { label: 'High-risk country', color: '#843939' },
};

const RISK_LEVEL_PLURAL_ITEMS: Record<TCountryRiskLevel, { label: string; color: string }> = {
  LOW: { ...RISK_LEVEL_ITEMS.LOW, label: 'Low-risk countries' },
  MEDIUM: { ...RISK_LEVEL_ITEMS.MEDIUM, label: 'Standard-risk countries' },
  HIGH: { ...RISK_LEVEL_ITEMS.HIGH, label: 'High-risk countries' },
};

const Container = styled(FlexBox)<{ color: string }>`
  border: 1px solid ${({ color }) => color};
  width: fit-content;
  max-width: 100%;
  padding: 0 8px;
  height: 20px;
  border-radius: 4px;
  justify-content: center;
  white-space: nowrap;
  align-items: center;
  & p {
    color: ${({ color }) => color}!important; 
  }
`;

const CountryRiskLevel: FC<ICountryRiskLevelProps> = ({
  riskLevel,
  usePluralLabel,
  customLabel,
}) => {
  return (
    <Container color={RISK_LEVEL_ITEMS[riskLevel].color}>
      <ThemeTypography variant="BODY_SMALLER_BOLD" autoOverflow>
        {customLabel || usePluralLabel
          ? RISK_LEVEL_PLURAL_ITEMS[riskLevel].label
          : RISK_LEVEL_ITEMS[riskLevel].label}
      </ThemeTypography>
    </Container>
  );
};

export default CountryRiskLevel;
